/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon64Regular = forwardRef('ArrowDUturnLeftDownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M20 28.5C20 17.73 28.73 9 39.5 9S59 17.73 59 28.5v15a1.5 1.5 0 0 1-3 0v-15C56 19.387 48.613 12 39.5 12S23 19.387 23 28.5v21.502c.13-.097.25-.208.363-.334L37.383 34a1.5 1.5 0 1 1 2.235 2L25.598 51.67a5.5 5.5 0 0 1-8.197 0L3.382 36a1.5 1.5 0 0 1 2.236-2l14.019 15.668c.112.126.234.237.363.334V28.5Z" })));
});
